import ProductTag from 'components/ProductTag';
import { usePriceContext } from 'contexts';
import type { ProductTag as ProductTagModel } from 'models/product';
import { cn } from 'utils/classNames';
import { is } from 'utils/helpers';

interface Props {
	className?: string;
	productTags: ProductTagModel[] | undefined;
}

export default function ProductSectionTags({ className, productTags }: Props) {
	const { usePriceExcVat } = usePriceContext();
	const tags = productTags?.filter((tag) => tag.section === 'Product');

	if (!is.arrayWithLength(tags)) {
		return null;
	}

	return (
		<div className={cn('flex flex-wrap gap-2', className)}>
			{tags.map((tag) => (
				<ProductTag
					key={tag.text}
					type={tag.type}
					text={usePriceExcVat && tag.textExcVat ? tag.textExcVat : tag.text}
					size="lg"
				/>
			))}
		</div>
	);
}
ProductSectionTags.displayName = 'ProductSectionTags';
